export default __webpack_public_path__ + "static/media/GP.608640d1.svg";